module.exports = __webpack_public_path__ + "img/funortemogi.a4eb5a87.png";